
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { vendorService } from "../../services/vendor.service";
import { useForm } from "react-hook-form";
import moment from "moment";
import LogicContext from "../../Context/LogicContext";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomDate, formatCustomDateWithoutTime } from "../../helpers/formatCustomDate";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";


function VendorLedgerTab(props) { 
  const [ledgerList, setLedgerList] =  useState([]);
    const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  
    const { showToast } = useContext(LogicContext); 
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  

  useEffect(() => {
    vendorService.vendorLedger(props.vendor_id).then(res => {
       const {ledger_info} = res.data;
      
      if(ledger_info?.length){
        setLedgerList(ledger_info);
      }
   

    })
  }, [props.vendor_id]);


    // Memoized columns to prevent recreation
    const columns = useMemo(
      () => [
        {
          title: " Ref",
          key: "ref_no",
          dataIndex: "ref_no",
          // className: "text-primary",
          sorter: (a, b) => (a?.ref_no ?? "") - (b?.ref_no ?? ""),
        },
            {
          title: "Date",
          dataIndex: "amount",
          sorter: (a, b) => (a?.amount ?? "").localeCompare(a?.amount ?? ""),
          render: (record) => <span> {formatCustomNumber(record)} </span>,
        },
    
            {
          title: "Date",
          dataIndex: "date",
          sorter: (a, b) => (a?.date ?? "").localeCompare(a?.date ?? ""),
          render: (record) => <span> {formatCustomDateWithoutTime(record)} </span>,
        },
    
        {
          title: "Type",
          dataIndex: "transaction_type_name",
          sorter: (a, b) => (a?.transaction_type_name ?? "").localeCompare(a?.transaction_type_name ?? ""),
  
        },
     
   
        // {
        //   title: "Warehouse",
        //   dataIndex: "purchase_receive_warehouse_name",
        //   sorter: (a, b) => (a?.purchase_receive_warehouse_name ?? "").localeCompare(b?.purchase_receive_warehouse_name ?? ""),
        // },
        //    {
        //   title: "Status",
        //   dataIndex: "purchase_receive_status_name",
        //   sorter: (a, b) => (a?.purchase_receive_status_name ?? "").localeCompare(b?.purchase_receive_status_name ?? ""),
        // },
   
  
    
    
    
      ],
      []
    );
  






       const handleRowClick = (item) => {
      const  {ref_no} =  item;
    // const customerRoute = `/${currModuleId}/${currModuleName}/purchase-receives/details/${purchase_receive_ref_no}`;
    // window.open(customerRoute, '_blank');

  }





  const searchByDate = useCallback(async () => {
    const formData = getValues();
    try {
      const response = await vendorService.getVendorLedgerByDate({...formData, vendor_id: props.vendor_id});
      const {purchase_receive_info} = response.data;
      if(purchase_receive_info?.length){
        setLedgerList(purchase_receive_info);
      }
   
    } catch (err) {
      showToast("Error", "error");
    }
  }, [getValues, showToast]);


  
    return (  
        <>
          <div
          className="tab-pane border-2 p-3 fade show active"
          id="tabs-home"
          role="tabpanel"
          aria-labelledby="tabs-home-tab"
        >
         <section>
                <div className="flex flex-row items-end space-x-2">
                   <div>
                     <span className="ml-1 text-sm">From Date:</span>
                     <input
                       defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                       {...register("from_date")}
                       className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
                       type="date"
                     />
                   </div>
                   <div>
                     <span className="ml-1 text-sm">To Date:</span>
                     <input
                       {...register("to_date")}
                       defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                       className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
                       type="date"
                     />
                   </div>
                   <div>
                     <button
                       onClick={searchByDate}
                       type="button"
                       className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
                     >
                       Search
                     </button>
                   </div>
                 </div>
         
         <div className="flex  justify-between">
            

            
            </div>

            
             <section className="mt-5">
                    <GeneralCustomTable
                      tableHeadList={columns}
                      tableDataList={ledgerList}
                      allowCheckBox={false}
                      setSelectedRows={()=> {}}
                      rowKey={(record) =>  {}}
                      handleRowClick={handleRowClick}
                    />
                  </section>

          </section>
          </div>
        </>
    );
}

export default VendorLedgerTab;